"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.get = void 0;
require("../../core");
const isObject_1 = require("./isObject");
const get = (obj, path, defaultValue) => {
    if (!isObject_1.isObject(obj) || Object.keys(obj).length === 0 || typeof path !== 'string' || path === '') {
        return (defaultValue !== null && defaultValue !== void 0 ? defaultValue : undefined);
    }
    const travel = (regexp) => path
        .split(regexp)
        .filter(Boolean)
        .reduce((res, key) => (res !== null && res !== undefined ? res[key] : res), obj);
    const result = travel(/[,[\]]+?/) || travel(/[,[\].]+?/);
    return (!result || result === obj ? defaultValue : result);
};
exports.get = get;
//# sourceMappingURL=get.js.map